import isEmpty from 'lodash-es/isEmpty';

const EXTERNAL_PATHS = [
  'blog',
  'classes',
  'home',
  'press-room',
  'referral_campaign',
  'reserve_class',
  'settings/membership',
  'studios',
];

const EXTERNAL_REGEXP = new RegExp(`^/?\\b(${EXTERNAL_PATHS.join('|')})\\b`);
const EXTERNAL_DOMAIN_REGEXP = new RegExp('^https?://');

export const isExternal = path => EXTERNAL_REGEXP.test(path) || EXTERNAL_DOMAIN_REGEXP.test(path);
export const isExternalDomain = path => EXTERNAL_DOMAIN_REGEXP.test(path);

export const redirectTo = (pathname, status = 301) => (_, replace, cb) => cb(replace({ pathname, state: { status } }));

export const toExternalHref = (href, secure = false) => {
  const protocol = secure ? 'https://' : 'http://';
  return isEmpty(href) || href.toLowerCase().indexOf('http') === 0 ? href : `${protocol}${href}`;
};
